import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import styles from "./Settings.module.css"
import SettingsPanelHeader from "../../components/settings/SettingsPanelHeader"
import { useDispatch, useSelector } from "react-redux";
import { addEditPoste, getPostesSettings, removePoste, PROTECTED_POSTE_IDS } from "./settingsSlice";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Langs, { Localize } from "../../app/lang/langs";
import { InputSwitch } from "primereact/inputswitch";
import { FilterMatchMode } from "primereact/api";
import { InputIcon } from "primereact/inputicon";
import { IconField } from "primereact/iconfield";
import { showErrorToast, showSuccessToast } from "../../app/utils/helpers";
import ImageButton from "../../components/buttons/ImageButton";
import addIcon from '../../assets/images/add.png'
import addIconFocus from '../../assets/images/addFocus.png'
import deleteIcon from '../../assets/images/delete.png'
import deleteIconFocus from '../../assets/images/delete-orange.png'
import AddPosteModal from "./Modals/AddPosteModal";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { InputText } from "primereact/inputtext";
import editIcon from '../../assets/images/edit.png'
import editIconFocus from '../../assets/images/editFocus.png'
import xIcon from "../../assets/images/reject.png";
import xIconFocus from "../../assets/images/rejectDanger.png";
import checkIcon from "../../assets/images/check.png";
import checkIconFocus from "../../assets/images/checkSuccess.png"
import { current } from "@reduxjs/toolkit";

export default function PostesTab() {

    const dispatch = useDispatch()

    const postesSlice = useSelector((state) => state.settings.postes)


    const [postes, setPostes] = useState([]);
    const [addModalVisible, setAddModalVisible] = useState(false)
    const [onEditPost, setOnEditPoste] = useState(null)
    const [onEditName, setOnEditName] = useState('')

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        name: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })
    const [globalFilterValue, setGlobalFilterValue] = useState('')

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }

    const mounted = useRef(null);

    useEffect(() => { setPostes(postesSlice) }, [postesSlice])

    useEffect(() => {
        if (!mounted.current) {
            mounted.current = true
        }
        dispatch(getPostesSettings())
    }, [mounted]);

    const handleActivatePoste = (e, rowData) => {
        if (e.value === true) {
            setPostes(
                postes.map(p => {
                    if (p.id === rowData.id) {
                        return {
                            ...p,
                            active: 1,
                        }
                    }
                    return p
                })
            )
            dispatch(addEditPoste({ id: rowData.id, active: 1 })).then((actionResponse) => {
                const { responseData, responseError } = actionResponse.payload || {};
                if (responseData && responseData.status) {
                    dispatch(getPostesSettings());
                    showSuccessToast("Poste activé")
                } else if (responseData && responseData.status === 0) {
                    showErrorToast(responseData.message);
                } else if (responseError) {
                    showErrorToast(responseError.data?.error || responseError.statusText);
                }
            })
        };
        if (e.value === false) {
            setPostes(
                postes.map(p => {
                    if (p.id === rowData.id) {
                        return {
                            ...p,
                            active: 0,
                        }
                    }
                    return p
                })
            )
            dispatch(addEditPoste({ id: rowData.id, active: 0 })).then((actionResponse) => {
                const { responseData, responseError } = actionResponse.payload || {};
                if (responseData && responseData.status) {
                    dispatch(getPostesSettings());
                    showErrorToast("Poste désactivé")
                } else if (responseData && responseData.status === 0) {
                    showErrorToast(responseData.message);
                } else if (responseError) {
                    showErrorToast(responseError.data?.error || responseError.statusText);
                }
            })
        };
    }

    const toggleActive = (rowData) => {
        return (
            <div className="d-flex justify-content-start">
                <InputSwitch
                    checked={rowData.active == 1}
                    onChange={(e) => { handleActivatePoste(e, rowData); }}
                />
            </div>
        )
    }
    const deleteButton = (rowData) => {
        if (PROTECTED_POSTE_IDS.includes(Number(rowData.id))) {
            return null
        }
        return (
            <ImageButton
                image={deleteIcon}
                imageFocus={deleteIconFocus}
                onClick={() => { confirmDelete(rowData.id, rowData.name) }}
                active={true}
                tooltip={<Langs str="DELETE_POSTE" />}
                width={24} />
        )
    }
    const confirmDelete = (id, name) => {
        const accept = () => {
            dispatch(removePoste({ id: id })).then((actionResponse) => {
                const { responseData, responseError } = actionResponse.payload || {};
                if (responseData && responseData.status) {
                    dispatch(getPostesSettings());
                    showSuccessToast(responseData.message)
                } else if (responseData && responseData.status === 0) {
                    showErrorToast(responseData.message);
                } else if (responseError) {
                    showErrorToast(responseError.data?.error || responseError.statusText);
                }
            })
        }

        const reject = () => {
            return
        }
        const message = (name) => {
            return <p className="my-2"><Langs str="DELETE_POSTE_MESSAGE" /> <b>{name}</b></p>
        }
        confirmDialog({
            message: message(name),
            icon: 'pi pi-exclamation-triangle',
            defaultFocus: 'accept',
            accept,
            reject
        });
    };

    const handleEditPoste = (name, id) => {
        if (name.trim() != '' && id != null) {
            dispatch(addEditPoste({ id: id, name: name }))
            setPostes(current => {
                return current.map(poste => {
                    if (poste.id == id) {
                        return {
                            ...poste,
                            name: name
                        };
                    }
                    return poste;
                });
            });
            setOnEditPoste(null);
            setOnEditName('')
        }
    }

    const editField = () => {
        return (
            <div>
                <InputText value={onEditName} onChange={(e) => setOnEditName(e.target.value)} />
                <ImageButton
                    image={xIcon}
                    imageFocus={xIconFocus}
                    onClick={() => { setOnEditPoste(null); setOnEditName('') }}
                    active={true}
                    tooltip={<Langs str="CANCEL" />}
                    width={18}
                />
                {onEditName.trim() != '' &&
                    <ImageButton
                        image={checkIcon}
                        imageFocus={checkIconFocus}
                        onClick={() => { handleEditPoste(onEditName, onEditPost) }}
                        active={true}
                        tooltip={<Langs str="EDIT_CLIENT" />}
                        width={28}
                    />}
            </div>
        )
    }
    const bodyColumn = (rowData) => {
        return (
            <div className="d-flex justify-content-between">
                {rowData.id == onEditPost ? editField(rowData.name, rowData.id) : rowData.name}
                <ImageButton
                    image={editIcon}
                    imageFocus={editIconFocus}
                    onClick={() => { setOnEditPoste(rowData.id); setOnEditName(rowData.name) }}
                    active={true}
                    tooltip={<Langs str="EDIT" />}
                    width={20}
                />
            </div>
        )
    }

    return (
        <div>
            <Row className="m-0">
                <Col xl={1}>
                </Col>
                <Col xl={8} className="d-flex align-content-center">
                    <div className={styles.menuContent}>
                        <SettingsPanelHeader
                            icon="pi-briefcase"
                            title={<Langs str="Postes" />}
                            description={<Langs str="SETTINGS_POSTES_DESC" />}
                            actions={
                                <>
                                    {postes.length > 0 && (
                                        <span className={styles.countBadge}>{postes.length}</span>
                                    )}
                                    <ImageButton
                                        image={addIcon}
                                        imageFocus={addIconFocus}
                                        onClick={() => { setAddModalVisible(true) }}
                                        active={true}
                                        tooltip={<Langs str="ADD_POSTE" />}
                                        width={26} />
                                </>
                            }
                        />
                        <div className={styles.filterBar}>
                            <IconField iconPosition="left">
                                <InputIcon className="pi pi-search" />
                                <InputText
                                    value={globalFilterValue}
                                    onChange={onGlobalFilterChange}
                                    placeholder={Localize("VSEC_SEARCH_PLACEHOLDER")}
                                />
                            </IconField>
                        </div>
                        <div className={styles.panelTable}>
                            <DataTable
                                value={postes}
                                scrollable
                                scrollHeight="calc(85vh)"
                                draggable={false}
                                globalFilterFields={['name']}
                                filters={filters}
                                emptyMessage={Localize("SETTINGS_POSTES_EMPTY_TITLE")}
                            >
                                <Column
                                    field="active"
                                    header={<Langs str="ACTIVE" />}
                                    body={toggleActive}
                                    style={{ width: '7rem' }}
                                ></Column>
                                <Column field="name" sortable body={bodyColumn} header={<Langs str="NAME" />} ></Column>
                                <Column
                                    field="id"
                                    body={deleteButton}
                                    alignFrozen="right"
                                    frozen={true}
                                    style={{ width: '5rem' }}
                                ></Column>
                            </DataTable>
                        </div>
                    </div>
                </Col>
            </Row>

            <AddPosteModal
                visible={addModalVisible}
                setVisible={setAddModalVisible}
            />
        </div>
    )
}
